module.exports = __webpack_public_path__ + "img/icon_atm_01.59529795.png";